import { Button, CircularProgress, Grid, TextField, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { PropertyFormInput } from '../../types/property';
import LocationInputField from '../common/LocationInputField';

type PropertyFormProps = {
  onSubmit: () => void;
  loading: boolean;
  formData: PropertyFormInput;
  setFormData: React.Dispatch<React.SetStateAction<PropertyFormInput>>;
  submitButtonText?: string;
  onlyAddress?: boolean;
};

export default function PropertyForm(props: PropertyFormProps) {
  const theme = useTheme();
  const [addressInputValue, setAddressInputValue] = useState<string>(
    props.formData.address1
      ? `${props.formData.address1}, ${props.formData.city}, ${props.formData.state} ${props.formData.zipcode}`
      : '',
  );

  return (
    <Grid container spacing={2} sx={styles.mainContainer}>
      {!props.onlyAddress && (
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            size={'small'}
            label={'Property Name'}
            name={'name'}
            value={props.formData.name}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              props.setFormData({ ...props.formData, name: event.target.value });
            }}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <LocationInputField
          addressInputValue={addressInputValue}
          setAddressInputValue={setAddressInputValue}
          onAddressSelect={address => {
            props.setFormData({
              ...props.formData,
              address1: address.address1,
              city: address.city || '',
              state: address.state || '',
              zipcode: address.postalCode || '',
            });
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Button fullWidth variant={'contained'} onClick={props.onSubmit}>
          {props.loading ? (
            <CircularProgress size={20} sx={{ color: theme.palette.background.default }} />
          ) : (
            props.submitButtonText || 'Submit'
          )}
        </Button>
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
};
